export default function isOneXpEnabled({ locale, pathname }) {
  switch (locale) {
    case 'en-US':
    case 'us':
      return !pathname?.includes('dtw-prospect');
    default:
      return true;
  }
}
